// PANTALLA 3 — Contexto de Uso (docs/onboarding-master-v2.md, Parte I §3)
import { useState } from 'react';
import OptionCards, { MicroReaction } from './OptionCards';
import { SCREEN3_HEADLINE, CONTEXTS } from './onboardingContent';
import { etiquetaDePaso } from './pasos';

export default function Screen3_Contexto({ value, onAnswer, onNext }) {
  const [selected, setSelected] = useState(value ?? null);

  const chosen = CONTEXTS.find((c) => c.value === selected);

  const handleSelect = (v) => {
    setSelected(v);
    onAnswer({ context_type: v });
  };

  return (
    <div className="ob-screen">
      <p className="ob-eyebrow">{etiquetaDePaso(4)}</p>
      <h1 className="ob-headline">
        <span className="ob-headline-linea">{SCREEN3_HEADLINE.linea}</span>
        <span className="ob-bloque">{SCREEN3_HEADLINE.bloque}</span>
      </h1>

      <OptionCards options={CONTEXTS} selected={selected} onSelect={handleSelect} />

      <MicroReaction text={chosen?.reaction} />

      {chosen && (
        <div className="ob-actions">
          <button type="button" className="ob-btn" onClick={onNext}>
            Continuar →
          </button>
        </div>
      )}
    </div>
  );
}
